'use strict';

/* globals grecaptcha */

const CONST = require('plugin_frontend_core/constants');
const backendSideValidation = require('app_storefront_base/components/formValidation');
const clientSideValidation = require('app_schuurman/components/clientSideValidation');

const $offlineChatButton = $('[data-js="offline-chat-button"]');
const $offlineChatWindow = $('[data-js="offline-chat-window"]');
const $offlineChatCollapse = $('[data-js="offline-chat-collapse"]');
const $offlineChatClose = $('[data-js="offline-chat-close"]');
const $offlineChatForm = $('[data-js="offline-chat-form"]');
const $offlineChatRecaptchaSettings = $('[data-js="offline-chat-recaptcha-settings"]');

/**
 * Switches between button and window.
 */
function toggleOfflineChat() {
    $offlineChatButton.toggleClass('d-none');
    $offlineChatWindow.toggleClass('d-none');
}

/**
 * Generates a timestamp for Recaptcha.
 */
function generateRecaptchaTimestamp() {
    const $recaptchaResponse = $offlineChatForm.find('#g-recaptcha-response');

    if (!$recaptchaResponse.length || $recaptchaResponse.val().trim() === '') {
        const settings = JSON.parse($offlineChatRecaptchaSettings.val());
        settings.ts = JSON.stringify(new Date().getTime());
        $offlineChatRecaptchaSettings.val(JSON.stringify(settings));
    }
}

module.exports = {
    init: function () {
        $offlineChatButton.on('click', toggleOfflineChat);
        $offlineChatCollapse.on('click', toggleOfflineChat);
        $offlineChatClose.on('click', function () {
            toggleOfflineChat();
            $offlineChatForm[0].reset();
        });
        $offlineChatForm.on('submit', function (e) {
            e.preventDefault();

            // performing client side validation
            if (!clientSideValidation.functions.validateForm($offlineChatForm, e)) {
                return;
            }

            // checking whether Recaptcha has been clicked
            if ($offlineChatRecaptchaSettings.length) {
                const $recaptchaResponse = $offlineChatForm.find('#g-recaptcha-response');

                if (!$recaptchaResponse.length || $recaptchaResponse.val().trim() === '') {
                    return;
                }
            }

            $.spinner().start();

            $.ajax({
                url: $offlineChatForm.attr('action'),
                method: $offlineChatForm.attr('method'),
                data: $offlineChatForm.serialize(),
                success: function (response) {
                    if (response.message) {
                        window.pubSub.publish(CONST.pubSubEvents.showNotification, {
                            msg: response.message,
                            result: response.success ? 'success' : 'error'
                        });
                    }

                    // showing errors after backend side validation
                    if (response.fields) {
                        backendSideValidation($offlineChatForm, response);
                    }

                    if (response.success) {
                        toggleOfflineChat();
                        $offlineChatForm[0].reset();
                    }
                },
                error: function () {
                    window.pubSub.publish(CONST.pubSubEvents.showNotification, {
                        msg: $offlineChatForm.data('response-message-error'),
                        result: 'error'
                    });
                },
                complete: function () {
                    $.spinner().stop();

                    if (grecaptcha) {
                        grecaptcha.reset();
                    }
                }
            });
        });

        if ($offlineChatRecaptchaSettings.length) {
            setInterval(generateRecaptchaTimestamp, 500);
        }

        // activating client side validation
        clientSideValidation.invalid($offlineChatForm);
        clientSideValidation.buttonClick($offlineChatForm);
    }
};
